export enum CancelSubscriptionEnum {
    CANCELLATION_DAY = 'cancellation_day',
    END_OF_BILLING_PERIOD = 'end_of_billing_period'
}
